import { LEAGUE_LABELS } from '@pickleballinc/lib/product-labels';

import { publicEnv } from '@/lib/env';
import { ModuleNoResultsMessages, ModuleType } from '@/types/players.types';

export const ALL_MODULES_PAGE_SIZE = 20;

export const TYPE_CONFIG = {
  tournament: {
    typeParamKey: 'tournament_type',
    typeItems: [
      { name: 'Registered', param: 'registeredfor' },
      { name: 'Managing', param: 'manage' },
      { name: 'Favorites', param: 'favorites' },
    ],
    searchPlaceholder: 'Search for tournament',
    statusKey: 'upcoming',
    statusItems: [
      { name: 'Active', param: 'true' },
      { name: 'Past', param: 'false' },
    ],
  },
  league: {
    typeParamKey: 'league_type',
    typeItems: [
      { name: 'Registered', param: 'registeredfor' },
      { name: 'Managing', param: 'manage' },
      { name: 'Favorites', param: 'favorites' },
    ],
    searchPlaceholder: `Search for ${LEAGUE_LABELS.singularLower}`,
    statusKey: 'status',
    statusItems: [
      { name: 'Active', param: 'current' },
      { name: 'Past', param: 'closed' },
    ],
  },
  teamLeague: {
    typeParamKey: 'team_league_type',
    typeItems: [
      { name: 'Member of', param: 'registeredfor' },
      { name: 'Managing', param: 'manage' },
      { name: 'Favorites', param: 'favorites' },
    ],
    searchPlaceholder: 'Search for team leagues',
    statusKey: 'status',
    statusItems: [
      { name: 'Active', param: 'future' },
      { name: 'Past', param: 'past' },
    ],
  },
  club: {
    typeParamKey: 'club_type',
    typeItems: [
      { name: 'Member of', param: 'memberof' },
      { name: 'Managing', param: 'manage' },
      { name: 'Favorites', param: 'favorites' },
    ],
    searchPlaceholder: 'Search for club',
    statusKey: null, // no status for clubs
    statusItems: null,
  },
} as const;

export const NO_RESULTS_MODULE_MESSAGES: Record<ModuleType, ModuleNoResultsMessages> = {
  tournament: {
    singular: 'Tournament',
    plural: 'Tournaments',
    createAction: 'Create Tournament',
    exploreAction: 'Explore Tournaments',
    exploreUrl: `${publicEnv.NEXT_PUBLIC_PT_URL}/search`,
  },
  league: {
    singular: LEAGUE_LABELS.singular,
    plural: LEAGUE_LABELS.plural,
    createAction: `Create ${LEAGUE_LABELS.singular}`,
    exploreAction: `Explore ${LEAGUE_LABELS.plural}`,
    exploreUrl: `${publicEnv.NEXT_PUBLIC_PL_URL}/leagues`,
  },
  teamLeague: {
    singular: 'Team League',
    plural: 'Team Leagues',
    createAction: '',
    exploreAction: 'Explore Team Leagues',
    exploreUrl: `${publicEnv.NEXT_PUBLIC_PTL_URL}`,
  },
  club: {
    singular: 'Club',
    plural: 'Clubs',
    createAction: 'Create Club',
    exploreAction: 'Explore Clubs',
    exploreUrl: `${publicEnv.NEXT_PUBLIC_PC_URL}`,
    createUrl: `${publicEnv.NEXT_PUBLIC_PC_URL}/create-club`,
  },
} as const;

export const PPA_CLUB_ID = '80f17003-cd92-4fc4-84e4-06d38e096042';

export const MEMBER_RANKINGS_IDS = [
  '43088F68-1F44-450F-8C7F-6F7AB3A94581',
  '2FB32E18-580C-433A-8D7D-4AD032C45B51',
  '16CE92C6-EEB5-4B68-9B9C-87BF57CEB855',
];

export const TEAM_LEAGUE_MODULE_FOR = 120;
export const ORGANIZATION_MODULE_FOR = 11;
export const MY_NEWS_PAGE_SIZE = 12;
